<template>
  <SearchField v-model="keyword" :limitWidth="limitWidth">
  </SearchField>
</template>


<script>
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import SearchField from "./SearchField.vue";

export default {
  name: "FilterSearch",
  props: {
    pk: {
      type: String,
      default: '',
    },
    limitWidth: {
      type: Boolean,
      default: true,
    },
    queryKey: {
      type: String,
      default: 'filter-keyword',
    },
  },
  components: {
    SearchField,
  },
  mixins: [FilterQueryMixin],

  data() {
    return {
    };
  },

  methods: {},

  computed: {
    keyword: {
      get() { return this.getQueryParam(this.queryKey, undefined); },
      set(update) { this.setQueryParam(this.queryKey, update); },
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>